module.exports = __webpack_public_path__ + "img/coincodex.6f051c70.png";